/*
 * Prestige — Designer Carousel
 * -------------------------------------------------------------
 * A horizontal row of cards that can either:
 *   • DRIFT — pan sideways as the section scrolls through the
 *     viewport (no scroll hijack; just a translate tied to the
 *     section's position). Reversible.
 *   • STATIC — behave as a normal carousel: drag to scroll +
 *     optional prev/next arrows.
 *
 * Config from data-* on [data-drift-carousel]:
 *   data-drift    "true" | "false"   (enable scroll-linked motion)
 *   data-strength  float             (how fast the drift pans)
 *
 * Reduced-motion forces STATIC. One rAF loop for all sections.
 */
(function () {
  if (window.__prestigeDesignerCarouselInit) return;
  window.__prestigeDesignerCarouselInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var drifters = [];
  var ticking = false;

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function overflowOf(it) {
    var d = it.track.scrollWidth - it.viewport.clientWidth;
    return d > 0 ? d : 0;
  }

  function updateDrift() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < drifters.length; i++) {
      var it = drifters[i];
      var rect = it.sec.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= vh) continue;
      // 0 as the section enters from the bottom, 1 as it leaves the top.
      var p = clamp((vh - rect.top) / (vh + rect.height), 0, 1);
      var tx = -clamp(p * it.strength, 0, 1) * it.overflow;
      it.track.style.transform = 'translate3d(' + tx.toFixed(1) + 'px,0,0)';
    }
  }

  function tick() { if (!ticking) { ticking = true; requestAnimationFrame(updateDrift); } }

  function sizeDrift() {
    for (var i = 0; i < drifters.length; i++) drifters[i].overflow = overflowOf(drifters[i]);
  }

  function initDrag(sec, viewport) {
    var down = false, startX = 0, startLeft = 0, moved = false;
    viewport.classList.add('is-draggable');
    viewport.addEventListener('pointerdown', function (e) {
      // Touch and pen already scroll natively, with momentum and snap. Capturing
      // them here and driving scrollLeft by hand fights the browser and makes the
      // swipe feel stiff, so only take over for a mouse drag.
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false;
      startX = e.clientX; startLeft = viewport.scrollLeft;
      viewport.setPointerCapture(e.pointerId);
      viewport.classList.add('is-grabbing');
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      viewport.scrollLeft = startLeft - dx;
    });
    function end() { down = false; viewport.classList.remove('is-grabbing'); }
    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
    viewport.addEventListener('pointerleave', end);
    // Prevent a drag from also firing card links.
    viewport.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    var arrows = sec.querySelectorAll('[data-dc-arrow]');
    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-dc-arrow') === 'prev' ? -1 : 1;
        var card = viewport.querySelector('.dc__card');
        var track = viewport.querySelector('.dc__track');
        // Read the real gap instead of assuming the old hard-coded 32px, so the
        // arrows land on a card edge for any "Gap between cards" setting.
        var gap = track ? parseFloat(getComputedStyle(track).columnGap) : NaN;
        if (isNaN(gap)) gap = 32;
        var step = card ? card.offsetWidth + gap : viewport.clientWidth * 0.8;
        viewport.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    });
  }

  function build(sec) {
    var viewport = sec.querySelector('.dc__viewport');
    var track = sec.querySelector('.dc__track');
    if (!viewport || !track) return;

    var drift = sec.getAttribute('data-drift') === 'true' && !reduce;
    if (drift) {
      sec.classList.add('dc--drift');
      var it = {
        sec: sec, viewport: viewport, track: track,
        strength: parseFloat(sec.getAttribute('data-strength')) || 1,
        overflow: 0
      };
      it.overflow = overflowOf(it);
      drifters.push(it);
    } else {
      sec.classList.add('dc--static');
      initDrag(sec, viewport);
    }
  }

  function collect() {
    drifters = [];
    document.querySelectorAll('[data-drift-carousel]').forEach(build);
  }

  function init() {
    collect();
    updateDrift();
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', function () { sizeDrift(); tick(); }, { passive: true });
    window.addEventListener('load', function () { sizeDrift(); tick(); });
    document.addEventListener('shopify:section:load', function () { collect(); sizeDrift(); tick(); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
